import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { siteRoutes } from '@views/common/models/routes.model';
import { Image } from '@vueling-ng/vy-ds';
import { StateManagerService } from 'app/shared/state/state-manager.service';
import { backgroundImage, emptyImage } from './models/page-layout';

@Component({
  selector: 'app-page-layout',
  templateUrl: './page-layout.component.html'
})
export class PageLayoutComponent {
  private readonly _stateManagerService: StateManagerService = inject(StateManagerService);
  private readonly _router = inject(Router);

  public state = this._stateManagerService._currentState;

  public getImageLayout(): Image {
    if (this._router.url === `/${siteRoutes.Booking}`) {
      return emptyImage;
    }
    return backgroundImage;
  }
}
